<template>
    <v-row>
        <v-col cols="6" v-for="(file, index) in files" v-if="audioCheck(file.name, file.type)" :key="file.itemKey">
            <v-row>
                <v-col cols="12">
                    <audio :src="fileLink(file)" controls></audio>
                </v-col>
                <v-col cols="12">
                    <v-btn icon small title="Конвертировать файл в mp3" v-if="!!showAdminUI && (fileExtension(file.name) !== 'mp3' || (file.file.indexOf('fit-service-bitrix') < 0))" class="mr-2" @click="convertToMp3(fileLink(file), file.name, file)"><v-icon small>mdi-refresh</v-icon></v-btn>
                    <v-btn icon small title="Скачать" :href="fileLink(file)" class="mr-2"><v-icon small>mdi-download</v-icon></v-btn>
                    <v-btn icon small title="Удалить" v-if="!!showAdminUI" @click="deleteAudio(file.itemKey)" class="mr-2"><v-icon small>mdi-delete</v-icon></v-btn>
                    <audio-renamer v-if="mode !== 'account' && mode !== 'franch' && mdoe !== 'uk'" :file="file" :mode="mode" @change="setFileName"></audio-renamer>
                    <span v-else>{{ file.name }}</span>
                </v-col>
            </v-row>

        </v-col>
        <v-col cols="12">Всего аудио файлов: {{ audioCount }}</v-col>
        <v-col cols="12" v-if="showAdminUI">
            <v-row>
                <v-col cols="4"><v-file-input v-model="newAudioFile" placeholder="Загрузить аудио"></v-file-input></v-col>
                <v-col cols="4"><v-btn color="success" @click="loadAudio">Загрузить</v-btn></v-col>
            </v-row>
        </v-col>
        <simple-loader-dialog text="Загрузка. Ожидайте" :show="showLoader"></simple-loader-dialog>
    </v-row>
</template>

<script>
  import moment from 'moment'
  import SimpleLoaderDialog from '../simpleLoaderDialog'
  import AudioRenamer from './audioRenamer'

  export default {
    name: 'audioCard',
    components: { AudioRenamer, SimpleLoaderDialog },
    props: ['value', 'mode', 'deal'],
    data() {
      return {
        newAudioFile: null,
        showLoader: false,
        files: this.value
      }
    },
    computed: {
      showAdminUI() {
        if(this.mode) {
          return this.mode !== 'uk' && this.mode !== 'franch' && this.mode !== 'account'
        } else {
          return true
        }
      },
      audioCount() {
        let audio = ['m4a', 'mp3', 'ogg', 'oga', '3gpp', 'aac']
        if(this.files) {
          let filez =  this.files.filter(f => {
            let fname = f.name.split('.')
            let sname = fname[fname.length - 1].toLowerCase()
            return audio.indexOf(sname) > -1 || f.type === 'audio'
          })
          return filez.length
        } else {
          return 0
        }
      },
    },
    methods: {
      setFileName: async function (value) {
        console.log('fileData', value)
        let iKey = value.fileInfo.itemKey
        if(iKey > 0) {
          for(let i in this.files) {
            if(iKey === this.files[i].itemKey) {
              this.files[i].name = JSON.parse(JSON.stringify(value.name))
            }
          }
          this.change()
        }
      },
      loadAudio: async function() {
        let data = this.newAudioFile
        let formData = new FormData()
        let uploadURL, field

        this.showLoader = true
        try {
          const r = await this.$http.post(`${this.$store.getters.bxapi}disk.folder.uploadfile?id=80614`)
          if(r.data.result) {
            uploadURL = r.data.result.uploadUrl
            field = r.data.result.field
            formData.append(field, this.newAudioFile, `${moment().format('YYYY_MM_DD_kk_mm_ss')}${this.newAudioFile.name}`)
          }
        } catch (e) {
          console.log('e')
        }

        if(field !== undefined) {
          try {
            const r = await this.$http.post(uploadURL,
              formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            )
            this.files.push({
              file: r.data.result.DOWNLOAD_URL,
              name: r.data.result.NAME,
              type: 'audio',
              itemKey: `${this.files.length}_${moment().format('x')}`
            })
          } catch (e) {
            console.log(e)
          }

        }
        this.newAudioFile = null
        this.showLoader = false
        this.change()
      },
      fileLink: function (file) {
        if(file.file.indexOf('fit-service-bitrix') > -1) return file.file
        return `https://sbotapi.fitauto.ru/v15/shopper/media/${this.deal}/${file.name}`
      },
      fileExtension: function(filename) {
        let fname = filename.split('.')
        return fname[fname.length - 1].toLowerCase()
      },
      convertToMp3: async function (url, name, fileData) {
        this.showLoader = true
        try {
          console.log('data', {url, name, fileData})
          const r = await this.$http.post(`${this.$store.getters.api}v4/media/convert/tomp3`, {
            url: url,
            detail: name
          })
          console.log('converted', r.data)
          if(r.data.error) {
            console.log('Ошибка конвертации файла: ' + r.data.error)
          } else {
            let fileName = r.data.result.NAME.split('.')

            this.files.push({
              file: r.data.result.DOWNLOAD_URL,
              name: r.data.result.NAME,
              type: 'audio',
              itemKey: `${this.files.length }_${moment().format('x')}`
            })

            this.$nextTick(function () {
              this.deleteAudio(fileData.itemKey)
            })
          }
        } catch (e) {
          console.log(e)
        }
        this.showLoader = false
      },
      deleteAudio(itemKey) {
        this.showLoader = true
        let key = -1
        for(let i in this.files) {
          console.log('iter', i, itemKey, this.files[i].itemKey)
          if(this.files[i].itemKey === itemKey) {
            key = i
            break
          }
        }
        if(key > -1) {
          console.log('delete', key, this.files[key])
          this.files.splice(key, 1)
          this.$nextTick(function () {
            this.change()
          })
        }
        this.showLoader = false
      },
      audioCheck(filename, type) {
        let types = ['m4a', 'mp3', 'ogg', 'oga', '3gpp', 'aac']
        let fname = filename.split('.')
        let sname = fname[fname.length - 1].toLowerCase()
        return types.indexOf(sname) > -1 || type === 'audio'
      },
      change() {
        this.$emit('input', this.files)
        this.$nextTick(function () {
          this.$emit('change')
        })
      }
    }
  }
</script>

<style scoped>

</style>
